import { useParams } from 'react-router-dom'
import { useMessages } from '@/i18n'
import { messages } from './messages'
import { CourseSettingsPage } from '@/features/editor/components/course-settings/CourseSettingsPage'

const CourseSettings = () => {
  const { courseId } = useParams<{ courseId: string }>()
  const id = Number(courseId)
  const m = useMessages(messages)
  if (!Number.isFinite(id)) return <div className="p-6">{m.invalidCourseId}</div>
  return <CourseSettingsPage courseId={id} />
}

export default CourseSettings
